// Módulos
import _ from 'lodash';
import cep from 'cep-promise';
import { mapActions, mapState } from 'vuex';
import { getBrazilianStates, getParameterByName, getErrorMessages, prepareSingleFileToUpload } from '@/utils';
import { postSupplier, postContractor, getContractor, getSupplier, updateContractor, updateSupplier } from '@/services';
import { KEYS, DOCUMENT_TYPE, USER_TYPE } from '@/utils/constants';
import { getCookie, setCookie } from '@/services/cookie-service';
import SubscriptionAlert from '@/components/modal/subscription-alert/';
import { saveFiles } from '@/services/s3-upload-service';
import editPassword from '@/components/modal/edit-password';
import Egfieldset from '@/components/signup/fieldset/';

export default {
    name: 'SignupForms',
    components: { SubscriptionAlert, editPassword, Egfieldset },
    data: () => ({
        showModalSubscription: false,
        updatePasswordModal: false,
        showAlertSnack: false,
        valid: false,
        message: '',
        textRules: {
            name: '',
            type: 'text',
            required: true,
            valid: true
        },
        idRules: {
            name: 'CNPJ',
            type: 'cnpj',
            required: true,
            valid: true
        },
        stateList: [{ label: 'Estado', value: '' }],
        id: '',
        primaryPhone: '',
        secondaryPhone: '',
        responsible: '',
        tradingName: '',
        website: '',
        postalCode: '',
        state: '',
        city: '',
        district: '',
        street: '',
        unit: '',
        complement: '',
        promotionalCode: '',
        userId: '',
        uuid: '',
        logo: undefined,
        previewLogoImage: [],
        previewCoverPhoto: [],
        previewPhotoPortfolio: [],
        photoPortfolio: [],
        aboutCompany: '',
        coverPhoto: '',
        getFullPathPhotoPortfolio: [],
        loading: false,
        isMobile: false,
        logoPath: ''
    }),
    async created() {
        this.setRules();
        this.stateList = this.stateList.concat(getBrazilianStates());
        await this.getUpdateUser();
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    methods: {
        ...mapActions('user', ['setUserType']),
        ...mapActions('notification', ['showNotification']),
        prepareLogoImage(e) {
            this.logo = e.target.files[0];
            this.previewLogoImage = [{ url: URL.createObjectURL(this.logo), name: this.logo.name }];
        },
        removeLogo() {
            this.logo = '';
            this.previewLogoImage = [];
        },
        prepareCoverPhoto(e) {
            this.coverPhoto = e.target.files[0];
            this.previewCoverPhoto = [{ url: URL.createObjectURL(this.coverPhoto), name: this.coverPhoto.name }];
        },
        removeCoverPhoto() {
            this.coverPhoto = '';
            this.previewCoverPhoto = [];
        },
        preparePhotoPortfolio(e) {
            const files = e.target.files
            for (let i = 0; i < files.length; i++) {
                this.photoPortfolio.push(files[i]);
                this.previewPhotoPortfolio.push({
                    url: URL.createObjectURL(files[i]),
                    name: files[i].name
                });
            }
        },
        removePhotoPortfolio(index) {
            this.photoPortfolio.splice(index, 1);
            if (typeof this.getFullPathPhotoPortfolio[index] != undefined) {
                this.$delete(this.getFullPathPhotoPortfolio, index);
            }
            this.previewPhotoPortfolio.splice(index, 1);
        },
        async getUpdateUser() {
            if (this.typeForm) {
                if (this.isSupplier) {
                    const supplier = await getSupplier();
                    this.overwideData(supplier[0]);
                } else {
                    const contractor = await getContractor();
                    this.overwideData(contractor[0]);
                }
            } else {
                return 0;
            }
        },
        async validateForm() {
            this.loading = true;
            this.valid = !this.valid;
            await setTimeout(() => {}, 500);
            const id = this.type == 'supplier' ? this.id.trim() != '' : true;
            if (id && this.formValid) {
                this.typeForm ? await this.sendUpdateProfile() : await this.sendSignupRequest();
            } else {
                window.scrollTo(0, 0);
                this.message = 'Preencha os campos Nescessários';
                this.textRules.valid = false;
                this.showAlertSnack = true;
                this.loading = false;
            }
        },
        async uploadFiles() {
            try {
                // logo
                if (this.logo instanceof File) {
                    try {
                        const logoBase64 = await prepareSingleFileToUpload(this.logo);
                        const uploadFilesToS3BucketResponse = await saveFiles([logoBase64]);
                        this.logo = uploadFilesToS3BucketResponse[0];
                    } catch (error) {
                        console.error(error);

                        this.logo = undefined;
                    }
                }
                // cover photo
                if (this.coverPhoto instanceof File) {
                    try {
                        const coverBase64 = await prepareSingleFileToUpload(this.coverPhoto);
                        const uploadFilesToS3BucketResponse = await saveFiles([coverBase64]);
                        this.coverPhoto = uploadFilesToS3BucketResponse[0];
                    } catch (error) {
                        console.error(error);
                    }
                }

                // portifólios
                if (this.photoPortfolio.length > 0) {
                    try {
                        const portifolioBase64 = [];
                        this.photoPortfolio.forEach(async photo => {
                            if (photo.name) {
                                const coverBase64 = await prepareSingleFileToUpload(photo);
                                portifolioBase64.push(coverBase64);
                            }
                        });
                        const uploadFilesToS3BucketResponse = await saveFiles(portifolioBase64);
                        uploadFilesToS3BucketResponse.map(uploded => {
                            return { url: uploded.path, path: uploded.path, name: uploded.name };
                        });

                        this.getFullPathPhotoPortfolio = [
                            ...this.getFullPathPhotoPortfolio,
                            ...uploadFilesToS3BucketResponse
                        ];
                    } catch (error) {
                        console.error(error);
                    }
                }
            } catch (error) {
                this.showNotification({
                    text: 'Houve um erro interno nos nossos servidores, tente novamente.',
                    type: 'error'
                });
            }
        },
        cleanFotosFields() {
            this.photoPortfolio = [];
        },
        async sendUpdateProfile() {
            try {
                await this.uploadFiles();
                const payload = await this.makePostData();
                this.isSupplier
                    ? await updateSupplier(this.userId, payload)
                    : await updateContractor(this.userId, payload);
                this.cleanFotosFields();
                this.showNotification({ text: 'Usuário atualizado com sucesso', type: 'success' });
            } catch (e) {
                console.error(e);
                this.showNotification({
                    text: 'Houve um erro interno nos nossos servidores, tente novamente.',
                    type: 'error'
                });
            } finally {
                this.loading = false;
            }
        },
        async sendSignupRequest() {
            this.showAlertSnack = false;
            await this.uploadFiles();
            let payload = await this.makePostData();
            payload = this.setType(payload);
            payload = _.merge({}, payload, this.getMarketingParameters());
            const { error } = this.type != 'supplier' ? await postContractor(payload) : await postSupplier(payload);
            if (error) {
                this.loading = false;
                window.scrollTo(0, 0);
                this.textRules.valid = false;
                this.message = getErrorMessages(error.response.data);
                return (this.showAlertSnack = true);
            }
            setCookie(KEYS.SIGNUP, 'signup', 14);
            this._sendSupplierCreatedAnalyticsEvent();
            await this.setUserType();
            if (getCookie(KEYS.PROMO_BANNER)) {
                this.showModalSubscription = true;
            } else {
                if (this.user.type.isSupplier) {
                    this.$router.push({ name: 'SupplierComplement' });
                } else {
                    this.$router.push({ name: 'ListCompetitions' });
                }
            }
            this.loading = false;
        },
        async makePostData() {
            return {
                city: this.city,
                complement: this.complement,
                document_identification: this.id,
                document_type: this.isCpf ? DOCUMENT_TYPE.CPF : DOCUMENT_TYPE.CNPJ,
                name: this.responsible,
                neighborhood: this.district,
                number: this.unit,
                phone: this.primaryPhone,
                postal_code: this.postalCode,
                secondary_phone: this.secondaryPhone,
                site: this.website,
                state: this.state,
                street: this.street,
                trading_name: this.tradingName,
                promotional_code: this.promotionalCode,
                logoImage: this.logo ? this.logo : null,
                coverPhoto: this.coverPhoto ? this.coverPhoto : null,
                aboutCompany: this.aboutCompany,
                photoPortfolio: { files: this.getFullPathPhotoPortfolio }
            };
        },
        overwideData(data) {
            this.city = data.city;
            this.complement = data.complement;
            this.id = data.documentIdentification;
            // document_type= data.isCpf
            this.responsible = data.name;
            this.district = data.neighborhood;
            this.unit = data.number;
            this.primaryPhone = data.phone;
            this.postalCode = data.postalCode;
            this.secondaryPhone = data.secondaryPhone;
            this.website = data.site;
            this.state = data.state;
            this.street = data.street;
            this.tradingName = data.tradingName;
            this.userId = data.id;
            this.uuid = data.uuid;
            this.aboutCompany = data.aboutCompany;
            this.getFullPathPhotoPortfolio = data.getFullPathPhotoPortfolio;
            if (data.logoImage) {
                this.logoPath = data.logoImage.fullPath;
                this.logo = data.logoImage
            }
            if (data.logoPath) this.previewLogoImage = [{ url: data.logoPath }];
            if (data.getFullPathCoverPhoto) {
                this.previewCoverPhoto = [{ url: data.getFullPathCoverPhoto.url }];
                this.coverPhoto = data.coverPhoto;
            }
            if (data.getFullPathPhotoPortfolio) {
                this.photoPortfolio = [...Array(data.getFullPathPhotoPortfolio.length).keys()];
                this.previewPhotoPortfolio = _.clone(data.getFullPathPhotoPortfolio);
            }
        },
        _sendSupplierCreatedAnalyticsEvent() {
            this.$gtag.event(this.getAnalyticsAction(this.type), {
                event_category: 'Cadastro'
            });
        },
        getAnalyticsAction: function(type) {
            switch (type) {
            case 'contractor':
                return 'Construcao Civil';
            case 'supplier':
                return 'Fornecedor';
            case 'physical-person':
                return 'Condominio';
            case 'condominum':
                return 'PJ ou PF';
            default:
                return 'Construcao Civil';
            }
        },
        getGoogleAnalyticsClientId() {
            let cookie = getCookie(KEYS.GOOGLE_ANALYTICS);
            if (cookie) {
                cookie = cookie.split('.');
                return cookie[2] + '.' + cookie[3];
            }
            return '';
        },
        getMarketingParameters() {
            const googleClickId = getCookie('googleClickId') || getParameterByName('gclid') || '';
            const googleClientId = getCookie('googleClientId') || this.getGoogleAnalyticsClientId() || '';
            const utmAdFormat = getCookie('utmAdFormat') || getParameterByName('utm_ad_format') || '';
            const utmCampaign = getCookie('utmCampaign') || getParameterByName('utm_campaign') || '';
            const utmContent = getCookie('utmContent') || getParameterByName('utm_content') || '';
            const utmMedium = getCookie('utmMedium') || getParameterByName('utm_medium') || '';
            const utmSource = getCookie('utmSource') || getParameterByName('utm_source') || '';
            // const utmTerm =
            // 	getCookie("utmTerm") || getParameterByName("utm_term") || "";

            return {
                google_click_id: googleClickId,
                google_client_id: googleClientId,
                utm_ad_format: utmAdFormat,
                utm_campaign: utmCampaign,
                utm_content: utmContent,
                utm_medium: utmMedium,
                utm_source: utmSource
            };
        },
        async viaCepRequest() {
            const data = await cep(this.postalCode).catch(console.log);
            if (Object.keys(data).length) {
                this.street = data.street;
                this.district = data.neighborhood;
                this.city = data.city;
                this.stateList.filter(s => {
                    if (s.value == data.state) return (this.state = data.state);
                });
            }
        },
        setRules() {
            if (this.type == 'supplier') this.idRules;
            else if (this.type == 'physical-person') {
                this.idRules = {
                    name: 'CPF',
                    type: 'cpf',
                    required: false,
                    valid: true
                };
            } else {
                this.idRules = {
                    name: 'CNPJ',
                    type: 'cnpj',
                    required: false,
                    valid: true
                };
            }
        },
        setType(data) {
            if (this.type == 'supplier') {
                data.supplier_type = USER_TYPE.SUPPLIER;
            } else if (this.type == 'physical-person') {
                data.contractor_type = USER_TYPE.PRIVATE_PERSON;
            } else if (this.type == 'condominum') {
                data.contractor_type = USER_TYPE.CONDOMINUM;
            }
            // contractor
            else data.contractor_type = USER_TYPE.CIVIL_CONSTRUCTION;
            return data;
        },
        goToProfileNetworkSupplier() {
            const routeData = this.$router.resolve({
                name: 'ProfileNetworkSupplier',
                params: {
                    id: this.uuid
                }
            });
            window.open(routeData.href, '_blank');
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('signup', ['signup']),
        type() {
            return this.signup.type;
        },
        isSupplier() {
            return this.user.type.isSupplier;
        },
        isCpf() {
            if (this.type == 'physical-person') return true;
            else return false;
        },
        idLabel() {
            if (this.type == 'supplier') return 'CNPJ';
            else if (this.type == 'physical-person') return 'CPF';
            else return 'CNPJ';
        },
        mask() {
            if (this.type == 'physical-person') return ['###.###.###-##'];
            else return ['##.###.###/####-##'];
        },
        formValid() {
            return this.idRules.valid && this.textRules.valid ? true : false;
        },
        btnColor() {
            return this.formValid ? 'blue' : 'gray';
        },
        typeForm() {
            return this.$route.name == 'EditProfile' || this.$route.name == 'EditProfileSupplier';
        },
        title() {
            if (this.typeForm) {
                return 'Editar perfil';
            } else if (this.type == 'supplier') {
                return 'Cadastro de fornecedor';
            } else {
                return 'Cadastro de contratante';
            }
        }
    }
};
